import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { registerMap } from 'echarts/lib/echarts';
import { VENN_MAP_NAME } from './config';
import vennStr from './mapStr';

export function registerVennMaps() {
  vennStr.forEach((map, index) => {
    registerMap(VENN_MAP_NAME[index], { svg: map });
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerPostInit(registerVennMaps);
}
